import { render } from "./CommentView.vue?vue&type=template&id=bb6a6aa0&scoped=true"
import script from "./CommentView.vue?vue&type=script&lang=js"
export * from "./CommentView.vue?vue&type=script&lang=js"

import "./CommentView.vue?vue&type=style&index=0&id=bb6a6aa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb6a6aa0"]])

export default __exports__